import { render, staticRenderFns } from "./WechatCategoryManager.vue?vue&type=template&id=28207562&scoped=true"
import script from "./WechatCategoryManager.vue?vue&type=script&lang=js"
export * from "./WechatCategoryManager.vue?vue&type=script&lang=js"
import style0 from "./WechatCategoryManager.vue?vue&type=style&index=0&id=28207562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28207562",
  null
  
)

export default component.exports